<template>
  <v-card :loading="loading">
    <v-card-title>
      <v-row align="center">
        <v-col cols="12" md="6">Today Class Schedules</v-col>
        <v-spacer></v-spacer>
        <v-col v-if="items.length > 0" cols="12" md="auto">
          <v-btn-toggle
            v-model="selectedTab"
            :block="$vuetify.breakpoint.mobile"
          >
            <v-btn v-for="(t, j) in tabs" :key="j">
              <v-icon left>{{ t.icon }}</v-icon>
              {{ t.text }}
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container v-if="items.length > 0" fluid>
        <v-slide-x-transition>
          <calendar-view
            v-show="selectedTab === tabView.calendar"
            type="day"
            :schedules="items"
            show-details
            hide-selections
          ></calendar-view>
        </v-slide-x-transition>
        <v-slide-x-transition>
          <v-timeline v-show="selectedTab === tabView.timeline" align-top dense>
            <v-timeline-item
              v-for="(schedule, i) in items"
              :key="i"
              :small="!isOngoingSchedule(schedule)"
              :color="getScheduleColor(schedule)"
            >
              <v-row>
                <v-col cols="12" md="3">
                  <v-icon left small>mdi-clock-outline</v-icon>
                  <strong>
                    {{ formatTime(schedule.start_time) }} -
                    {{ formatTime(schedule.end_time) }}
                  </strong>
                  <v-chip
                    :color="getScheduleColor(schedule)"
                    small
                    class="mx-1"
                  >
                    {{ getScheduleText(schedule) }}
                  </v-chip>
                </v-col>
                <v-col cols="12" md="7">
                  <h4 class="mb-2">{{ schedule.classroom.name }}</h4>
                  <div v-if="schedule.lessons.length > 0">
                    <ul>
                      <li v-for="(lesson, j) in schedule.lessons" :key="j">
                        {{ bilingualText(lesson, 'name', 'name_cn') }}
                      </li>
                    </ul>
                    <v-btn
                      v-if="isLessonsDownloadable(schedule)"
                      outlined
                      color="success"
                      small
                      class="my-1"
                      :href="
                        $route(
                          'classroom-schedules.download-lessons',
                          schedule.id
                        )
                      "
                      target="_blank"
                    >
                      <v-icon left>mdi-cloud-download</v-icon> Download Lessons
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="12" md="2" class="text-right" align-self="center">
                  <v-btn
                    color="info"
                    text
                    class="my-1"
                    small
                    :href="$route('classroom-schedules.detail', schedule.id)"
                  >
                    See Details
                  </v-btn>
                </v-col>
              </v-row>
            </v-timeline-item>
          </v-timeline>
        </v-slide-x-transition>
      </v-container>
      <div v-else class="text-center">No class today</div>
    </v-card-text>
  </v-card>
</template>
<script>
import CalendarView from '@components/ClassroomSchedule/CalendarView'

const TAB_TIMELINE_VIEW = 0
const TAB_CALENDAR_VIEW = 1

export default {
  name: 'TodayClassSchedules',
  components: {
    CalendarView,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedTab: 0,
      tabs: [
        {
          text: 'Timeline View',
          icon: 'mdi-view-list',
          view: 'timeline',
        },
        {
          text: 'Calendar View',
          icon: 'mdi-calendar-month',
          view: 'calendar',
        },
      ],
      tabView: {
        timeline: TAB_TIMELINE_VIEW,
        calendar: TAB_CALENDAR_VIEW,
      },
    }
  },
  methods: {
    isPastSchedule(schedule, unit) {
      const now = moment()
      const dt = moment(`${schedule.class_date} ${schedule.end_time}`)
      if (unit) {
        return dt.isSameOrBefore(now, unit)
      }
      return dt.isBefore(now)
    },
    isOngoingSchedule(schedule, unit) {
      const now = moment()
      const dt1 = moment(`${schedule.class_date} ${schedule.start_time}`)
      const dt2 = moment(`${schedule.class_date} ${schedule.end_time}`)
      if (unit) {
        return dt1.isSameOrAfter(now, unit) && dt2.isSameOrBefore(now, unit)
      }
      return now.isSameOrAfter(dt1) && now.isSameOrBefore(dt2)
    },
    isUpcomingSchedule(schedule, unit) {
      const now = moment()
      const dt = moment(`${schedule.class_date} ${schedule.start_time}`)
      if (unit) {
        return dt.isAfter(now, unit)
      }
      return dt.isAfter(now)
    },
    getScheduleColor(schedule, unit) {
      if (this.isPastSchedule(schedule, unit)) {
        return 'grey'
      } else if (this.isOngoingSchedule(schedule, unit)) {
        return 'warning'
      } else if (this.isUpcomingSchedule(schedule, unit)) {
        return 'success'
      }
    },
    getScheduleText(schedule, unit) {
      if (this.isPastSchedule(schedule, unit)) {
        return 'Ended'
      } else if (this.isOngoingSchedule(schedule, unit)) {
        return 'Ongoing'
      } else if (this.isUpcomingSchedule(schedule, unit)) {
        return 'Upcoming'
      }
    },
    isLessonsDownloadable(schedule) {
      return (
        schedule.lessons &&
        schedule.lessons.length > 0 &&
        schedule.lessons.some((e) => e.attachment_file_url)
      )
    },
  },
}
</script>
